import React from "react";
import { ModalDialog } from "../../../../components";
import PAGES from "../../../../../../constants/pages";

const NoneOrderModal: React.FC = () => {
    function continueClicked(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        window.location.assign(PAGES.LISTING_PAGES.MOBILE.URL);
    }

    return (
        <ModalDialog
            size="medium"
            submitText="Fortsett"
            closeText="Lukk"
            heading="Ups, der skjedde det noe..."
            name="none-order-modal"
            onSubmit={continueClicked}
        >
            Vi finner ikke din bestilling i våre systemer, og du må dessverre starte helt på nytt igjen. Hvis dette ikke
            hjelper, så må du ta kontakt med vårt kundesenter.
        </ModalDialog>
    );
};

export default NoneOrderModal;
